import brandLoader from './brandLoader';
import { loadPartnerWhiteLabel } from '../stores/brand';
import { loadListing } from '../stores/monthlyCheckout';
import { loadVehicles } from '../stores/vehicle';
import { loadPaymentMethods } from '../stores/payments';

const partnerCheckoutLoader = async ({
  dispatch,
  params,
  getState,
  apolloClient
}) => {
  const listingId = parseInt(params.listingId, 10);
  const { partnerName } = params;

  const whiteLabel = dispatch(loadPartnerWhiteLabel(partnerName));
  const listing = dispatch(loadListing(listingId));
  const vehicles = dispatch(loadVehicles());
  const payments = dispatch(loadPaymentMethods(listingId));
  const brand = brandLoader(dispatch, partnerName, getState(), apolloClient);

  await Promise.all([whiteLabel, listing, vehicles, payments, brand]);

  return brand;
};

export default partnerCheckoutLoader;
